import { queryOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { axiosDelete, axiosGet, axiosPost, axiosPut } from '../utils/api';

export const getArticles = ({ accessToken, params } = {}) =>
  queryOptions({
    queryKey: ['/articles', params],
    queryFn: async () => {
      const res = await axiosGet('/articles', { params }, accessToken);
      return res.data;
    },
    staleTime: 2 * 60 * 1000, // 2 min - avoid duplicate fetches on remount (e.g. Strict Mode)
  });

export const getPublishedArticles = ({ params } = {}) =>
  queryOptions({
    queryKey: ['/articles/published', params],
    queryFn: async () => {
      const res = await axiosGet('/articles/published', { params });
      return res.data;
    },
  });

export const getArticle = (id) =>
  queryOptions({
    queryKey: ['/articles', id],
    queryFn: async () => {
      const res = await axiosGet(`/articles/${id}`);
      return res.data;
    },
    enabled: !!id,
  });

export const useCreateArticle = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ data }) => axiosPost('/articles', data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['/articles'] }),
  });
};

export const useUpdateArticle = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => axiosPut(`/articles/${id}`, data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['/articles'] }),
  });
};

export const useDeleteArticle = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id }) => axiosDelete(`/articles/${id}`),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['/articles'] }),
  });
};
